export const GET_TERM_OF_SERVICE_REQUEST =
  "resource/GET_TERM_OF_SERVICE_REQUEST";
export const GET_TERM_OF_SERVICE_SUCCESS =
  "resource/GET_TERM_OF_SERVICE_SUCCESS";
export const GET_TERM_OF_SERVICE_FAIL = "resource/GET_TERM_OF_SERVICE_FAIL";

export const GET_INTRODUCTION_REQUEST = "resource/GET_INTRODUCTION_REQUEST";
export const GET_INTRODUCTION_SUCCESS = "resource/GET_INTRODUCTION_SUCCESS";
export const GET_INTRODUCTION_FAIL = "resource/GET_INTRODUCTION_FAIL";

export const GET_PRIVATE_POLICY_REQUEST = "resource/GET_PRIVATE_POLICY_REQUEST";
export const GET_PRIVATE_POLICY_SUCCESS = "resource/GET_PRIVATE_POLICY_SUCCESS";
export const GET_PRIVATE_POLICY_FAIL = "resource/GET_PRIVATE_POLICY_FAIL";

export const GET_USAGE_RULES_REQUEST = "resource/GET_USAGE_RULES_REQUEST";
export const GET_USAGE_RULES_SUCCESS = "resource/GET_USAGE_RULES_SUCCESS";
export const GET_USAGE_RULES_FAIL = "resource/GET_USAGE_RULES_FAIL";

export const GET_TERM_BEFORE_LOGIN = "resource/GET_TERM_BEFORE_LOGIN";
export const GET_TERM_BEFORE_LOGIN_SUCCESS =
  "resource/GET_TERM_BEFORE_LOGIN_SUCCESS";
export const GET_TERM_BEFORE_LOGIN_FAIL = "resource/GET_TERM_BEFORE_LOGIN_FAIL";

export const GET_HOLIDAY_REQUEST = "resource/GET_HOLIDAY_REQUEST";
export const GET_HOLIDAY_SUCCESS = "resource/GET_HOLIDAY_SUCCESS";
export const GET_HOLIDAY_FAIL = "resource/GET_HOLIDAY_FAIL";

export const GET_BANNER_LIST_REQUEST = "resource/GET_BANNER_LIST_REQUEST";
export const GET_BANNER_LIST_SUCCESS = "resource/GET_BANNER_LIST_SUCCESS";
export const GET_BANNER_LIST_FAIL = "resource/GET_BANNER_LIST_FAIL";

export const GET_ALL_CAREERS_REQUEST = "resource/GET_ALL_CAREERS_REQUEST";
export const GET_ALL_CAREERS_SUCCESS = "resource/GET_ALL_CAREERS_SUCCESS";
export const GET_ALL_CAREERS_FAIL = "resource/GET_ALL_CAREERS_FAIL";
export const CHANGE_CAREER = "resource/CHANGE_CAREER";

export const GET_ALL_NATION_REQUEST = "resource/GET_ALL_NATION_REQUEST";
export const GET_ALL_NATION_SUCCESS = "resource/GET_ALL_NATION_SUCCESS";
export const GET_ALL_NATION_FAIL = "resource/GET_ALL_NATION_FAIL";
export const CHANGE_NATION = "resource/CHANGE_NATION";

export const GET_ALL_CITIES_BY_COUNTRY_REQUEST =
  "resource/GET_ALL_CITIES_BY_COUNTRY_REQUEST";

export const GET_ALL_CITIES_BY_COUNTRY_SUCCESS =
  "resource/GET_ALL_CITIES_BY_COUNTRY_SUCCESS";
export const GET_ALL_CITIES_BY_COUNTRY_FAIL =
  "resource/GET_ALL_CITIES_BY_COUNTRY_FAIL";
export const CHANGE_CITY = "resource/CHANGE_CITY";
export const RESET_CITY = "resource/RESET_CITY";

export const GET_ALL_CITIES_V2_BY_COUNTRY_REQUEST =
  "resource/GET_ALL_CITIES_V2_BY_COUNTRY_REQUEST";

export const GET_ALL_CITIES_V2_BY_COUNTRY_SUCCESS =
  "resource/GET_ALL_CITIES_V2_BY_COUNTRY_SUCCESS";
export const GET_ALL_CITIES_V2_BY_COUNTRY_FAIL =
  "resource/GET_ALL_CITIES_V2_BY_COUNTRY_FAIL";
export const CHANGE_CITY_V2 = "resource/CHANGE_CITY_V2";
export const RESET_CITY_V2 = "resource/RESET_CITY_V2";

export const GET_ALL_COUNTRIES_REQUEST = "resource/GET_ALL_COUNTRIES_REQUEST";
export const GET_ALL_COUNTRIES_SUCCESS = "resource/GET_ALL_COUNTRIES_SUCCESS";
export const GET_ALL_COUNTRIES_FAIL = "resource/GET_ALL_COUNTRIES_FAIL";
export const CHANGE_COUNTRY = "resource/CHANGE_COUNTRY";
export const RESET_SELECTED_COUNTRY = "resource/RESET_SELECTED_COUNTRY";

export const GET_ALL_DISTRICTS_BY_CITY_REQUEST =
  "resource/GET_ALL_DISTRICTS_BY_CITY_REQUEST";
export const GET_ALL_DISTRICTS_BY_CITY_SUCCESS =
  "resource/GET_ALL_DISTRICTS_BY_CITY_SUCCESS";
export const GET_ALL_DISTRICTS_BY_CITY_FAIL =
  "resource/GET_ALL_DISTRICTS_BY_CITY_FAIL";
export const CHANGE_DISTRICT = "resource/CHANGE_DISTRICT";
export const RESET_DISTRICT = "resource/RESET_DISTRICT";

export const GET_ALL_WARDS_BY_DISTRICT_REQUEST =
  "resource/GET_ALL_WARDS_BY_DISTRICT_REQUEST";
export const GET_ALL_WARDS_BY_DISTRICT_SUCCESS =
  "resource/GET_ALL_WARDS_BY_DISTRICT_SUCCESS";
export const GET_ALL_WARDS_BY_DISTRICT_FAIL =
  "resource/GET_ALL_WARDS_BY_DISTRICT_FAIL";
export const CHANGE_WARD = "resource/CHANGE_WARD";
export const RESET_WARD = "resource/RESET_WARD";

export const GET_ALL_WARDS_V2_BY_CITY_REQUEST =
  "resource/GET_ALL_WARDS_V2_BY_CITY_REQUEST";
export const GET_ALL_WARDS_V2_BY_CITY_SUCCESS =
  "resource/GET_ALL_WARDS_V2_BY_CITY_SUCCESS";
export const GET_ALL_WARDS_V2_BY_CITY_FAIL =
  "resource/GET_ALL_WARDS_V2_BY_CITY_FAIL";
export const CHANGE_WARD_V2 = "resource/CHANGE_WARD_V2";
export const RESET_WARD_V2 = "resource/RESET_WARD_V2";

export const GET_ALL_RELATIONSHIP_REQUEST =
  "resource/GET_ALL_RELATION_SHIP_REQUEST";
export const GET_ALL_RELATIONSHIP_SUCCESS =
  "resource/GET_ALL_RELATION_SHIP_SUCCESS";
export const GET_ALL_RELATIONSHIP_FAIL = "resource/GET_ALL_RELATION_SHIP_FAIL";
export const CHANGE_RELATIONSHIP = "resource/CHANGE_RELATIONSHIP";
